module.exports = __webpack_public_path__ + "img/青蒿.d1eccc2b.jpg";